import React from 'react';

import Typography from 'components/typography/typography';
import { createLocale } from 'locales';
import { useOrganisationJobDetail } from 'state/context/organization/OrganisationJobDetail';
import Link from 'components/link/link';

const localize = createLocale('organizationPlannerJobDetailsLocales');

const Documents: React.FC = () => {
  const {
    userContext: { data: user },
  } = useOrganisationJobDetail();
  return (
    <div className="bg-white flex-1 flex flex-col flex-wrap border-gray200/60 border-2 pt-4 px-6 pb-8 rounded-md gap-5">
      <Typography variant="body-large-bold" as="p">
        {localize('documents')}
      </Typography>
      <div className="flex flex-col gap-3 overflow-scroll max-h-44">
        {!!user.documents &&
          user.documents?.length !== 0 &&
          user.documents.map((document, index) => {
            return (
              <div
                key={`${document.name} ${index.toString()}`}
                className="text-gray800 flex justify-between items-center cursor-default"
              >
                <Typography
                  variant="body-medium"
                  as="p"
                  className="text-gray800"
                >
                  {document.name}
                </Typography>
                {!!document.pdf && (
                  <Link
                    href={document.pdf}
                    className="hover:opacity-70 flex cursor-pointer border-none text-gray600"
                    variant="outlined"
                    label={localize('download')}
                    iconProps={{
                      className: 'text-gray600/80',
                      icon: 'download',
                    }}
                    labelClassName="text-body-small"
                    target="_blank"
                    download
                  />
                )}
                {!!document.picture && !document.pdf && (
                  <Link
                    href={document.picture}
                    className="hover:opacity-70 flex cursor-pointer border-none text-gray600"
                    variant="outlined"
                    label={localize('download')}
                    iconProps={{
                      className: 'text-gray600/80',
                      icon: 'download',
                    }}
                    labelClassName="text-body-small"
                    target="_blank"
                    download
                  />
                )}
              </div>
            );
          })}
        {!user.documents ||
          (user.documents?.length === 0 && (
            <Typography as="p" variant="body-large">
              {localize('noDocumentExist')}
            </Typography>
          ))}
      </div>
    </div>
  );
};

export default Documents;
